import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "readonly",
})(({ theme }) => ({
  "& .MuiTableBody-root .MuiTableCell-root": {
    paddingTop: 0,
    paddingBottom: 0,
  },
  "& .subTable": {
    "& .MuiTableCell-root": {
      padding: "0 .5rem",
      "&:first-of-type": { padding: 0 },
      "&:not(:first-of-type)": { minWidth: "6.25rem" },
    },
    "& .MuiTableCell-body": {
      padding: "0.25rem .5rem",
      "&:first-of-type": { padding: 0 },
      "&:not(:first-of-type)": { minWidth: "6.25rem" },
    },
    "& .infoGrid": { marginTop: 0 },
    "& .infoGrid > div": { padding: 0, marginBottom: 0 },
    "& > div > .MuiPaper-root": {
      background: undefined,
      ...theme.applyStyles("light", { background: "#f6f6f6" }),
    },
  },
  "& .licenseCards": {
    "& .MuiCard-root": {
      minWidth: 250,
      maxWidth: 700,
      flex: 1,
      display: "flex",
      flexDirection: "column",
      height: "100%",
      backgroundColor: "#252525",
      ...theme.applyStyles("light", { backgroundColor: undefined }),
    },
    "& .MuiCardContent-root": undefined,
    "& .MuiCardActions-root": {
      justifyContent: "flex-end",
      border: 0,
      borderTop: 1,
      borderColor: theme.palette.text.disabled,
      borderStyle: "solid",
    },
    "& .headingContainer": {
      display: "flex",
      justifyContent: "space-between",
    },
    "& .dateContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
    },
    "& .MuiDivider-root": {
      marginTop: "0.5rem",
      borderBottomWidth: "medium",
      borderColor: "#76c836",
    },
    "& .MuiCheckbox-root:not(.Mui-disabled)": {
      color: "#76c836",
    },
    "& .MuiList-root": {
      display: "flex",
      flexDirection: "column",
      gap: "1rem",
      overflow: "auto",
      marginLeft: "-0.5rem",
      marginRight: "-0.5rem",
      paddingRight: "0.5rem",
      paddingLeft: "0.5rem",
      maxHeight: "21rem",
      "&::-webkit-scrollbar": {
        width: "5px",
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: "1rem",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.text.disabled,
        borderRadius: "1rem",
        ...theme.applyStyles("light", { backgroundColor: "#d9d9d9" }),
      },
    },
  },

  variants: [
    {
      props: ({ readonly }) => readonly,
      style: {
        "& .MuiTableBody-root .MuiTableCell-root": { paddingTop: undefined },
      },
    },
    {
      props: ({ readonly }) => readonly,
      style: {
        "& .MuiTableBody-root .MuiTableCell-root": { paddingBottom: undefined },
      },
    },
    {
      props: ({ readonly }) => !readonly,
      style: {
        "& .licenseCards": {
          "& .MuiCardContent-root": { flex: 1, border: 0, borderBottom: 1 },
        },
      },
    },
  ],
}));

export default StyledBox;
